<div class="flex flex-col -m-6 w-auto overflow-hidden">

    <!-- Header -->
    <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-4 sm:pl-4 bg-primary text-on-primary">
      <div class="text-lg font-medium">
        <i class="fa-solid fa-camera"></i>
        New Profile Photo</div>
    </div>
  
    <div class="image-container mt-4 mb-8">
      <label class="hoverable" for="fileInput">
        <img *ngIf="url" [src]="url" />
        <i *ngIf="!url" class="fa-solid fa-upload fa-2x"></i>
        <div class="hover-text">Choose Photo</div>
        <div class="background"></div>
      </label>
      <br />
      <input
        id="fileInput"
        type="file"
        [(ngModel)]="url"
        class="select-profile-picture"
        (change)="onSelectFile($event)"
        accept=".jpeg, .jpg, .png"
      /> 
    </div>
  
    <div class="flex items-center justify-end mt-auto mr-2">
      <button mat-button (click)="matDialogRef.close()">
        Cancel
      </button>
      <button *ngIf="url"
        class="px-6 ml-3"
        mat-flat-button
        [color]="'primary'"
        (click)="save()">
        Load
      </button>
      <button *ngIf="!url"
        class="px-6 ml-3"
        mat-flat-button
        [color]="'primary'"
        (click)="remove()">
        Remove
      </button>
    </div>
  
  </div>
  